/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { GET_LIST, UPDATE } from 'react-admin';
import { Button } from 'ra-ui-materialui';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import _ from 'lodash';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';

class AllowInvestPostClosingButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDialogOpen: false,
      offers: [],
    };
  }

  onCheck = (id) => {
    const { offers } = this.state;
    const indexOf = _.findIndex(offers, { id });
    if (indexOf >= 0) {
      offers[indexOf].isSelected = !offers[indexOf].isSelected;
      this.setState({ offers });
    }
  }

  handleClick = async () => {
    const { dataProvider, data } = this.props;
    const { postCloseInvestmentsAllowedIn = [] } = data;
    const result = await dataProvider(GET_LIST, 'offerings', { filter: { status: 'closed' } });
    const offers = result.data.map(({ id, name }) => ({ id, name, isSelected: postCloseInvestmentsAllowedIn && postCloseInvestmentsAllowedIn.includes(id) }));
    this.setState({ offers, isDialogOpen: true });
  }

  handleSubmit = async () => {
    const {
      dataProvider, resource, data, setSubmitting,
    } = this.props;
    setSubmitting(true);
    const { offers } = this.state;
    this.setState({ isDialogOpen: false });
    dataProvider(UPDATE, resource, {
      data: {
        postCloseInvestmentsAllowedIn:
          offers.filter(({ isSelected }) => isSelected).map(({ id }) => id),
      },
      id: data.id,
    }, {
      onSuccess: {
        notification: { body: 'Preference Successfully Saved!', level: 'info' },
        refresh: true,
        callback: () => {
          setSubmitting(false);
        },
      },
      onError: {
        notification: { body: 'Preference could not be successfully saved!', level: 'warning' },
        callback: ({ error }) => {
          // eslint-disable-next-line no-console
          console.log('ERROR', error);
          setSubmitting(false);
        },
      },
    });
  }

  render() {
    const {
      isDialogOpen,
      offers,
    } = this.state;
    const areAllChecked = offers.filter(({ isSelected }) => isSelected).length === offers.length;
    return (
      <div>
        <Button
          variant="contained"
          label="Allow Invest Post Closing"
          style={{ width: '100%', marginTop: 4 }}
          className="blue userActionButton"
          onClick={this.handleClick}
        >
          <AddShoppingCartIcon />
        </Button>
        <Dialog
          open={isDialogOpen}
          onClose={() => this.setState({ isDialogOpen: false })}
          maxWidth="lg"
          style={{ height: '100%' }}
        >
          <DialogTitle id="alert-dialog-title">
            Configure Preference
          </DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <DialogContentText
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                  marginTop: 5,
                }}
              >
                Choose the Closed Offer(s) to allow
                <br />
                Post-Close Investing:
              </DialogContentText>
              <Button
                label={areAllChecked ? 'Uncheck All' : 'Check All'}
                onClick={() => this.setState({
                  offers: areAllChecked ?
                    offers.map(offer => ({ ...offer, isSelected: false })) :
                    offers.map(offer => ({ ...offer, isSelected: true })),
                })}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 0,
                }}
              />
            </div>
            <div className="row">
              {offers.length === 0 && 'No Offers Found'}
              {offers.length > 0 && offers.map(({ id, name, isSelected }) => (
                <div style={{ width: '19%' }}>
                  <FormControlLabel
                    key={`${id}_checkbox`}
                    control={
                      <Checkbox
                        name={`offer_${id}`}
                        value={id}
                        checked={isSelected}
                        onChange={() => this.onCheck(id)}
                      />}
                    label={name}
                  />
                </div>
              ))}
            </div>
            <div className="row">
              <hr
                style={{
                  width: '100%',
                  border: '1px solid lightgrey',
                }}
              />
            </div>
          </DialogContent>
          <DialogActions style={{ paddingTop: 15, paddingBottom: 15 }}>
            <div style={{ width: '50%', textAlign: 'right' }}>
              <Button
                style={{ paddingRight: 15, marginRight: 10 }}
                variant="contained"
                color="default"
                label="Cancel"
                onClick={() => this.setState({ isDialogOpen: false })}
              />
              <Button
                style={{ paddingRight: 15, marginRight: 15 }}
                variant="contained"
                color="primary"
                label="Save"
                onClick={this.handleSubmit}
              />
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default (AllowInvestPostClosingButton);



// WEBPACK FOOTER //
// ./src/components/User/actions/actions/AllowInvestmentPostClosingButton.jsx